import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0",
  class: "with_white_bg",
  style: {"margin":"0","border-bottom":"1px solid #eee"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "w100 skyblueBg centered fw600 fs12",
    style: {"height":"5px","padding-top":"0px","letter-spacing":"0.3px"}
  })
], -1)
const _hoisted_3 = { style: {"text-align":"left","width":"100%","padding":"10px 20px 15px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#8e8e8e","margin-top":"-3px"} }, "クラウド日程調整", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tbody", null, [
      _hoisted_2,
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_3, [
          (_ctx.rm && _ctx.rm.logo_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  "data-imagetype": "External",
                  src: _ctx.rm.logo_url,
                  style: {"max-width":"140px"},
                  height: "35"
                }, null, 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("img", {
                  "data-imagetype": "External",
                  src: _ctx.$getAssetImageUrl(`/assets/logo/waaqLink_logo_flat.gif`),
                  width: "140",
                  height: "17"
                }, null, 8, _hoisted_9)
              ]))
        ])
      ])
    ])
  ]))
}